import triggerPopup from "../components/_trigger-popup";
import toggleVideoModal from "../components/_toggle-video-modal";

toggleVideoModal("vimeo");
triggerPopup(".video-modal");
